import { HTMLAttributeAnchorTarget, ReactNode } from "react";

/** A standarized link button with icon for an action row in the details form.
 * href turns to # when the linkbutton ist disabled.
 */
export function LinkButtonWithIcon(props: {
  /** The href of the link button */
  href: string;
  disabled?: boolean;
  /** Icon to display, the wrapper element applies padding and margin */
  icon: ReactNode;
  /** Class to apply to the link button, `btn-primary` by default */
  buttonClass: string;
  /** The text in the button */
  buttonText: string;
  /** Target, _self by default*/
  target?: string;
}) {
  let buttonClass = props.buttonClass || "btn-primary";
  let target: HTMLAttributeAnchorTarget | undefined = props.target || "_self";

  return (
    <a
      href={props.disabled ? "#" : props.href}
      target={target}
      rel="noreferrer"
      className={`btn  py-1 me-2 ps-4 pe-5 ${
        props.disabled ? "disabled" : ""
      } ${buttonClass}`}
      style={{ marginTop: "8px" }}
    >
      <span className="ps-2 me-3">{props.icon}</span> {props.buttonText}
    </a>
  );
}

export default LinkButtonWithIcon;
